import script from "./CRMStatus+CRMSummary+RelevantBusiness+ClientUpdateNotes+OutreachNotesCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMStatus+CRMSummary+RelevantBusiness+ClientUpdateNotes+OutreachNotesCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__